import {
    optionTitle_blockedSendersAndDomains,
    optionSearchTerms_blockedSendersAndDomains,
} from './BlockedSendersAndDomainsOptionV2.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const BlockedSendersAndDomainsOptionV2: LazyOption = createLazyOption(
    {
        key: 'blockedSendersAndDomainsV2',
        titleStringKey: optionTitle_blockedSendersAndDomains,
        searchTermsStringKey: optionSearchTerms_blockedSendersAndDomains,
        isHidden: () => {
            return IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default BlockedSendersAndDomainsOptionV2;
